var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Avatar, makeStyles } from "@material-ui/core";
import AvatarIcon from "../../assets/icons/ic_avatar_placeholder.svg";
import BrandIcon from "../../assets/icons/ic_brand_placeholder.svg";
const sizeToPx = {
    small: "32px",
    xsmall: "24px",
    normal: "48px",
    large: "96px",
};
export default (_a) => {
    var { size = "normal", type = "avatar", src } = _a, other = __rest(_a, ["size", "type", "src"]);
    const classes = useStyles();
    return (React.createElement(Avatar, Object.assign({ className: classes[size], classes: { root: classes.root }, src: src, imgProps: {
            alt: type,
            width: sizeToPx[size],
            height: sizeToPx[size],
        } }, other),
        React.createElement("img", { alt: type, src: type === "avatar" ? AvatarIcon : BrandIcon, width: sizeToPx[size], height: sizeToPx[size], className: classes[size] })));
};
const useStyles = makeStyles({
    root: {
        background: "#C4CBD4",
    },
    xsmall: {
        width: "24px",
        height: "24px",
    },
    small: {
        width: "32px",
        height: "32px",
    },
    normal: {
        width: "48px",
        height: "48px",
    },
    large: {
        width: "96px",
        height: "96px",
    },
});
//# sourceMappingURL=FTLAvatar.js.map